// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://brij-api-v1.empirecinemas.com`;
export const SOCKETURL = `https://brij-socket-api.empirecinemas.com`;
// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://d1mhwzn85vwitg.cloudfront.net/`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;



// WEBPACK FOOTER //
// ./src/config/index.js